var pad4Lr = {
  "paddingLeft": "2.5rem !important",
  "paddingRight": "2.5rem !important"
};

export { pad4Lr };
